import { jsx } from 'react/jsx-runtime';
import { twMerge } from 'tailwind-merge';
import 'react';
import '../../Base/Layouts/Box/Box.js';
import '../../Base/Layouts/FullBleed/FullBleed.js';
import ProductIcon from '../../DataDisplays/ProductIcon/ProductIcon.js';
import Checkbox from '../Checkbox/Checkbox.js';

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const CheckboxCardContainer = (_param)=>{
    var { children, isWide, checked, isError, disabled, className } = _param, rest = _object_without_properties(_param, [
        "children",
        "isWide",
        "checked",
        "isError",
        "disabled",
        "className"
    ]);
    const generateBorderStyles = ()=>{
        const CHECKED_NON_ERROR = checked && !isError;
        if (disabled) return twMerge('cursor-not-allowed', CHECKED_NON_ERROR ? 'border-primary-100' : 'border-w-gray-200');
        if (isError) return 'border-w-red-500';
        if (checked) return 'border-primary-500';
        return 'border-w-gray-200 group-hover:border-primary';
    };
    const generateBackgroundStyles = ()=>{
        const CHECKED_NON_ERROR = checked && !isError;
        if (disabled) return CHECKED_NON_ERROR ? 'bg-primary-10' : 'bg-w-gray-10';
        if (checked) return isError ? 'bg-w-red-10' : 'bg-primary-10';
        return 'bg-w-white';
    };
    return /*#__PURE__*/ jsx("div", _object_spread_props(_object_spread({
        className: twMerge('relative flex h-auto cursor-pointer items-center gap-2 rounded-xl border', isWide ? 'min-h-[94px] w-[298px] flex-row gap-3 px-5 py-4' : 'min-h-fit w-[224px] flex-col justify-center px-4 pb-6 pt-4', generateBorderStyles(), generateBackgroundStyles(), className)
    }, rest), {
        children: children
    }));
};
const TitleContainer = ({ isWide, children })=>{
    return /*#__PURE__*/ jsx("div", {
        className: twMerge('flex h-auto w-full flex-col justify-between gap-0.5', isWide ? 'items-start' : 'items-center'),
        children: children
    });
};
const StyledCheckbox = (_param)=>{
    var { isWide, className } = _param, rest = _object_without_properties(_param, [
        "isWide",
        "className"
    ]);
    const isNormal = !isWide;
    return /*#__PURE__*/ jsx(Checkbox, _object_spread({
        className: twMerge(isNormal && 'absolute left-[17px] top-[17px] group-hover:border-primary-500', className)
    }, rest));
};
const CheckboxCardIcon = ({ iconName, disabled, checked, isError })=>{
    const isIconDisabled = isError || !checked;
    return /*#__PURE__*/ jsx("div", {
        className: twMerge('flex size-[60px] flex-shrink-0 items-center justify-center', disabled && 'opacity-30'),
        "data-testid": "design-system-checkboxCard--icon",
        children: /*#__PURE__*/ jsx(ProductIcon, {
            name: iconName,
            disabled: isIconDisabled
        })
    });
};

export { CheckboxCardContainer, CheckboxCardIcon, StyledCheckbox, TitleContainer };
